"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonOnboardingStepId = void 0;
var CommonOnboardingStepId;
(function (CommonOnboardingStepId) {
    /**
     * Step where the user has to verify his e-mail address.
     */
    CommonOnboardingStepId["EMAIL_VERIFICATION"] = "EMAIL_VERIFICATION";
    /**
     * Step where the user has to fill in his personal information and must provide the necessary information to prove his identity.
     */
    CommonOnboardingStepId["IDENTITY"] = "IDENTITY";
    /**
     * Step where the user has to fill in his payment information.
     */
    CommonOnboardingStepId["PAYMENT_INFO"] = "PAYMENT_INFO";
})(CommonOnboardingStepId = exports.CommonOnboardingStepId || (exports.CommonOnboardingStepId = {}));
//# sourceMappingURL=CommonOnboardingStepId.js.map